<template>
  <div>
    <div class="pb-8">
      <h1 class="pb-4 text-navy">{{ headerText }}</h1>
      <p class="text-navy opacity-75 leading-normal">{{ headerCopy }}</p>
    </div>
    <form @submit.prevent="onSubmit()" class="w-full">

      <div class="flex flex-wrap mb-6" v-if="!aggregator">
        <div class="w-full">
          <FieldText namespace="broker" field="name" label="Full Name" placeholder="Sam Jones" :validation-rule="{required: true, regex:'^(.*)( )(.*)[a-zA-Z]$' }" validation-message="Please enter broker's first and last name" :disabled="getLockedStatus('name')"></FieldText>
        </div>
      </div>

      <div class="flex flex-wrap mb-6" v-if="aggregator">
        <div class="w-full md:w-1/2 pr-0 md:pr-4 mb-6 md:mb-0">
          <FieldText namespace="broker" field="name" label="Full Name" placeholder="" :validation-rule="{required: true, }" validation-message="Please enter broker's first and last name" :disabled="getLockedStatus('name')"></FieldText>
        </div>
        <div class="w-full md:w-1/2 pl-0 md:pl-4">
          <FieldText namespace="broker" field="aggregator.name" label="Aggregator" :disabled="true"></FieldText>
        </div>
      </div>

      <div class="flex flex-wrap mb-6">
        <div class="w-full md:w-1/2 pr-0 md:pr-4 mb-6 md:mb-0">
          <FieldText namespace="broker" :maskFormat="'##/##/####'" fieldType="date" field="dob" label="Date of birth" validation-message="Broker must be at least 18 years of age to sign up" :validation-rule="`required|date_format:DD/MM/YYYY|before:${dobBefore}`" placeholder="DD/MM/YYYY"></FieldText>
        </div>
        <div class="w-full md:w-1/2 pl-0 md:pl-4">
          <FieldEmail :async="true" namespace="broker" field="email" label="Email address" placeholder="user@domain.com" :disabled="getLockedStatus('email')"></FieldEmail>
        </div>
      </div>

      <div class="flex flex-wrap mb-6">
        <div class="w-full md:w-1/2 pr-0 md:pr-4 mb-6 md:mb-0">
          <FieldText namespace="broker" field="mobileNumber" label="Mobile number" placeholder="04XXXXXXXX" validation-message="Please enter a valid mobile number" :validation-rule="{required: true, regex:'^0([0-9]{9})$' }" :disabled="getLockedStatus('mobileNumber')"></FieldText>
        </div>
        <div class="w-full md:w-1/2 pl-0 md:pl-4">
          <FieldText namespace="broker" field="telephoneNumber" label="Business telephone number (Optional)" :validation-rule="{required: false, regex:'^\\D*\\d(\\D*\\d){9}\\D*$'}" validation-message="Please enter a valid Business phone number" placeholder="" :disabled="getLockedStatus('telephoneNumber')"></FieldText>
        </div>
      </div>

      <div class="flex flex-wrap mb-6">
        <div class="w-full md:w-1/2 pr-0 md:pr-4 mb-6 md:mb-0">
          <FieldText namespace="broker" field="businessName" label="Business name" placeholder="Acme Inc" validation-rule="required" validation-message="Please enter the broker's business name" :disabled="getLockedStatus('businessName')"></FieldText>
        </div>
        <div class="w-full md:w-1/2 pl-0 md:pl-4">
          <FieldText namespace="broker" :maskFormat="'## ### ### ###'" field="abnNumber" label="ABN number" placeholder="" :validation-rule="{required: true, regex:'^(\\d *?){11}$' }" validation-message="Please enter a valid ABN number" :disabled="getLockedStatus('abnNumber')"></FieldText>
        </div>
      </div>

      <!-- only show if aggregator is mcmillan shakespeare -->
      <div v-if="aggregatorId === '5c9913aa-f6e3-41f5-ba04-e3f9cf9f5428'">
          <div class="w-full md:w-1/2 pr-0 md:pr-4 mb-6 md:mb-6">
             <FieldDropdown namespace="broker" field="subAggregator" label="Sub-Aggregator" :options="['National Finance Choice Pty Ltd','United Financial Services Pty Ltd','United Financial Services Queensland Pty Ltd','United Financial Services Network Pty Ltd']" placeholder="Select" :disabled="getLockedStatus('subAggregator')"></FieldDropdown>
      </div>
      </div>
      <div class="flex flex-wrap mb-6">
        <div class="w-full">
          <FieldText v-if="getLockedStatus('businessAddress')" namespace="broker" field="businessAddress" label="Business Address" placeholder="" validation-rule="required" validation-message="Please enter a valid address" :disabled="getLockedStatus('businessAddress')"></FieldText>
          <FieldAddress2 v-else id="addressOfBusiness" namespace="broker" field="businessAddress" label="Business Address" validationMessage="Please enter a valid address. For e.g - 12 Smith St, Richmond, VIC 2131" />
        </div>
      </div>

      <div class="flex flex-wrap mb-6">
        <div class="w-full">
          <FieldText namespace="broker" field="postalAddress" label="Postal address (Optional)" placeholder="" :disabled="getLockedStatus('postalAddress')"></FieldText>
        </div>
      </div>

      <div class="flex flex-wrap mb-6">
        <div class="w-full md:w-1/2 pr-0 md:pr-4 mb-6 md:mb-0">
          <FieldText namespace="broker" field="aclNumber" label="Acl Number" placeholder="" validation-rule="required|digits:6" validation-message="Please enter a valid ACL number" :disabled="getLockedStatus('aclNumber')"></FieldText>
        </div>
        <div class="w-full md:w-1/2 pl-0 md:pl-4">
          <FieldText namespace="broker" field="acrNumber" label="ACR number (if applicable)" placeholder="" validation-rule="digits:6" validation-message="Please enter a valid ACR number" :disabled="getLockedStatus('acrNumber')"></FieldText>
        </div>
      </div>

      <div v-if="formType === 'aggregator'">
        <h3 class="pb-4 text-navy">{{ docText }}</h3>
        <p class="text-navy opacity-75 mb-4 leading-normal">{{ docCopy }}</p>
        <div class="flex flex-wrap mb-6">
          <div class="w-full">
            <FieldFile validation-message="Please upload a file" field="insuranceUrl"  label="Current professional indemnity insurance as required by ACL"></FieldFile>
          </div>
        </div>

        <div class="flex flex-wrap mb-6">
          <div class="w-full">
            <FieldFile validation-message="Please upload a file" field="membershipUrl"  label="Proof of membership with the MFAA or FBAA"></FieldFile>
          </div>
        </div>
      </div>

      <div v-if="displayPasswordField">
        <WidgetPassword namespace="broker" field="password" label="Create your password (This will be used with your email to log into the SocietyOne Broker Portal)" validationMessage="Please ensure a password has been set and that the passwords match"></WidgetPassword>
      </div>
      <div class="md px-4 md:px-0 container mx-auto mt-8">
        <div>
          <div v-if="formType === 'aggregator'" class="my-4">
            <h2 class="text-navy leading-loose">Bank Account Information</h2>
            <p class="text-navy-light leading-normal">Please provide bank account information for us to disburse any broker assistance fees. You may also leave this section blank and let the broker input the information.</p>
          </div>
           <div v-else class="my-4">
            <h2 class="text-navy leading-loose">Bank Account Information</h2>
            <p class="text-navy-light leading-normal">Please provide or verify the bank account information that the broker assistance fees will be disbursed to (if necessary).</p>
          </div>
          <div v-if="editBankDetails" class="flex flex-wrap mb-6">
            <div class="w-full mb-4">
              <FieldText namespace="broker" field="bankName" label="Bank Name" placeholder="Enter the name of your bank" :disabled="getLockedStatus('bankName')"></FieldText>
            </div>
            <div class="w-full md:w-1/2 pr-0 md:pr-4 mb-6 md:mb-0">
              <FieldText namespace="broker" field="bsb" label="BSB Number" placeholder="Enter your BSB number" validation-message="Please enter a valid BSB (without dashes or hyphens)" :validation-rule="{ required: false, regex: '^([0-9]+)$' }" :disabled="getLockedStatus('bsb')"></FieldText>
            </div>
            <div class="w-full md:w-1/2 pl-0 md:pl-4">
              <FieldText namespace="broker" field="bankAccountNumber" label="Account Number"  placeholder="Enter your bank account number" validation-message="Please enter a valid bank account number" :validation-rule="{ required: false, regex: '^([0-9]+)$' }" :disabled="getLockedStatus('bankAccountNumber')"></FieldText>
            </div>
          </div>
          <div v-else class="flex flex-wrap mb-6">
            <div class="w-full mb-4">
              <FieldText namespace="broker" field="bankName" label="Bank Name" placeholder="Enter the name of your bank"></FieldText>
            </div>
            <div class="w-full md:w-1/2 pr-0 md:pr-4 mb-6 md:mb-0">
              <FieldText namespace="broker" field="bsb" label="BSB Number" placeholder="Enter your BSB number" validation-message="Please enter a valid BSB (without dashes or hyphens)" validation-rule="digits:6"></FieldText>
            </div>
            <div class="w-full md:w-1/2 pl-0 md:pl-4">
              <FieldText namespace="broker" field="bankAccountNumber" label="Account Number"  placeholder="Enter your bank account number" validation-message="Please enter a valid bank account number" :validation-rule="{ required: false, regex: '^([0-9]+)$' }"></FieldText>
            </div>
          </div>
        </div>
      </div>

      <div v-if="formType === 'aggregator'">
        <div class="flex flex-wrap mb-6">
          <div class="w-full">
              <FieldCheckbox connectedField field="editBankDetails" namespace="broker" label="I don't want the broker to edit the bank account details"></FieldCheckbox>
          </div>
        </div>
      </div>

      <div v-if="formType === 'aggregator'">
        <div class="flex flex-wrap mb-6">
          <div class="w-full">
            <FieldCheckbox field="agreement" :label="tacLabel" validation-rule="required" validation-message="Please confirm broker affiliation to aggregator"></FieldCheckbox>
          </div>
        </div>
      </div>

      <div v-if="formType !== 'aggregator'">
        <div class="flex flex-wrap mb-6">
          <div class="w-full">
            <FieldCheckbox field="agreement" label="I confirm that the information above is correct" validation-rule="required" validation-message="Please confirm"></FieldCheckbox>
          </div>
        </div>
      </div>

      <div v-if="formType !== 'aggregator'">
        <div class="flex flex-wrap mb-6">
          <div class="w-full">
            <FieldCheckbox field="agreementTerms" label="I agree to the <a class='text-grey-darker' href='https://docs.societyone.com.au/ASSETS/Broker+Terms+and+Conditions.pdf' target='_blank'>SocietyOne Broker Terms and Conditions</a>" validation-rule="required" validation-message="Please confirm"></FieldCheckbox>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap">
        <div class="w-full">
          <button @click="onSubmit" class="bg-green hover:opacity-75 text-white font-bold py-3 px-4 rounded text-lg" type="button" v-if="formType === 'aggregator'">
            Submit
          </button>
          <button @click="onSubmit" class="bg-green hover:opacity-75 text-white font-bold py-3 px-4 rounded text-lg" type="button" v-if="formType !== 'aggregator'">
            Continue
          </button>
        </div>
      </div>

      <div class="mt-6 pb-4">
        <p class="text-sm text-grey-dark opacity-100">Need help? Contact us at (02) 7501 1110 Mon-Fri (8am-5pm AEST) or email 1-brokersupport@moneyme.com.au</p>
      </div>

    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import FieldText from './FieldText';
import FieldDate from './FieldDate';
import FieldDropdown from './FieldDropdown';
import FieldEmail from './FieldEmail';
import FieldFile from './FieldFile';
import FieldCheckbox from './FieldCheckbox';
import WidgetPassword from './WidgetPassword';
import FieldAddress2 from '@/components/FieldAddress2';
import { escapeHtml } from '@/utils/sanitize';

export default {
  name: 'BrokerSignUpForm',
  components: {
    FieldText,
    FieldDate,
    FieldDropdown,
    FieldEmail,
    FieldFile,
    FieldCheckbox,
    WidgetPassword,
    FieldAddress2,
  },
  props: {
    displayPasswordField: {
      type: Boolean,
    },
    editBankDetails: {
      type: Boolean,
    },
    aggregator: {
      default: false,
    },
    aggregatorId: {
      type: String,
      default: '',
    },
    headerText: {
      type: String,
      default: 'Broker Accreditation Request',
    },
    headerCopy: {
      type: String,
      default:
        'To request broker accreditation with SocietyOne, please provide the following broker details:',
    },
    docText: {
      type: String,
      default: 'Accreditation Documents (if applicable)',
    },
    docCopy: {
      type: String,
      default:
        'If your broker has their own accreditation documents, please upload them below :',
    },
    lockedFields: {
      type: Array,
      default: () => [
      ],
    },
    formType: {
      type: String,
      default: 'aggregator',
    },
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    tacLabel() {
      const tokenData = this.$auth.getTokenData();
      // FieldCheckbox renders its label with v-html; the aggregator name is stored data.
      return `I confirm that the broker is a member of ${escapeHtml(tokenData.name)}`;
    },
    dobBefore: () =>
      moment()
        .subtract(18, 'years')
        .format('DD/MM/YYYY'),
  },
  methods: {
    ...mapActions({
      submitForm: 'broker/submitForm',
    }),
    async onSubmit() {
      try {
        const validate = await this.$validator.validateAll();

        if (validate) {
          const response = await this.submitForm(this.formType);
          if (response) {
            if (this.formType === 'aggregator') {
              this.$router.push('/aggregator/broker-creation-success');
              window.scroll(0, 0)
            } else {
              this.$auth.setToken(response.body.token);
              this.$router.replace('/broker/complete-registration');
            }
          }
        } else {
          window.scroll(0, 0);
          this.$toasted.error('Please check the information you\'ve entered');
        }
      } catch (e) {
        this.$toasted.error(
          `Error: ${(e.body && e.body.error) ||
          e.message ||
          'Something went wrong'}`
        );
      }
    },
    getLockedStatus(field) {
      return this.lockedFields.includes(field);
    },
  },
};
</script>

<style lang="postcss">
@tailwind utilities;
.label {
  @apply .block .uppercase .tracking-wide .text-navy-light .text-xs .mb-2 .leading-normal;
}
.field {
  @apply .appearance-none .block .w-full .bg-grey-lighter .text-navy .border .rounded .py-3 .px-4;
}

.field-disabled {
  @apply .bg-grey;
}
</style>



// WEBPACK FOOTER //
// src/components/BrokerSignUpForm.vue